const httpUrl = process.env.BASE_API
const globalServices = {
    //⽣成base64图形验证码
    base64captchaCode: {
        method: 'post',
        url: `${httpUrl}/api/v1/authUser/base64captchaCode`,
        needToken:false,
    },
    //登录
    authUserLogin: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authUser/authUserLogin`,
        needToken:true,
    },
    //拿到登录后返回的数据
    queryLoginMeta: {
        method: 'GET',
        url: `${httpUrl}/api/v1/authUser/queryLoginMeta`,
        needToken:true,
    },
    //分页系统用户
    queryAuthUserByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authUser/queryByPage`,
        needToken:true,
    },
    //批量删除
    batchDeleteAuthUser: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authUser/batchDeleteItem`,
        needToken:true,
    },
    //新增系统用户
    addAuthUserItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authUser/addItem`,
        needToken:true,
    },
    //编辑系统用户
    editAuthUserItem: {
        method: 'PUT',
        url: `${httpUrl}/api/v1/authUser/updateItem`,
        needToken:true,
    },
    //查询所有用户信息
    queryAllAuthUser: {
        method: 'GET',
        url: `${httpUrl}/api/v1/authUser/queryAllAuthUser`,
        needToken:true,
    },
    //根据字典类型查询字典数据
    queryDictByType: {
        method: 'GET',
        url: `${httpUrl}/api/v1/platformDict/queryDictByType`,
        needToken:false,
    },
    queryPlatformDictByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformDict/queryByPage`,
        needToken:true,
    },
    batchDeletePlatformDict: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformDict/batchDeleteItem`,
        needToken:true,
    },
    addPlatformDictItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformDict/addItem`,
        needToken:true,
    },
    editPlatformDictItem: {
        method: 'PUT',
        url: `${httpUrl}/api/v1/platformDict/updateItem`,
        needToken:true,
    },
    // 退出
    logOut: {
        method: 'post',
        url: `${httpUrl}/api/v1/authUser/logOut`,
        needToken:true,
    },
    //根据用户ID查询用户的角色信息
    queryRoleByAuthUserId: {
        method: 'GET',
        url: `${httpUrl}/api/v1/authUser/queryRoleByAuthUserId`,
        needToken:true,
    },
    // 查询登录信息
    queryLoginUserMeta: {
        method: 'get',
        url: `${httpUrl}/api/v1/authUser/queryLoginUserMeta`,
        needToken:true,
    },
    //系统权限相关模块
    queryAuthPermissionByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authPermission/queryByPage`,
        needToken:true,
    },
    //查询权限树集合
    queryPermissionNodeList: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authPermission/queryPermissionNodeList`,
        needToken:true,
    },
    //查询权限树集合
    queryPermissionTreeList: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authPermission/queryPermissionTreeList`,
        needToken:true,
    },
    //根据主键ID查询菜单信息
    queryPermissionByMainId: {
        method: 'GET',
        url: `${httpUrl}/api/v1/authPermission/queryPermissionByMainId`,
        needToken:true,
    },
    //查询所有权限树集合
    queryAllPermissionNodeList: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authPermission/queryAllPermissionNodeList`,
        needToken:true,
    },
    //批量删除权限
    batchDeleteAuthPermission: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authPermission/batchDeleteItem`,
        needToken:true,
    },
    //新增权限
    addAuthPermissionItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authPermission/addItem`,
        needToken:true,
    },
    //编辑权限
    editAuthPermissionItem: {
        method: 'PUT',
        url: `${httpUrl}/api/v1/authPermission/updateItem`,
        needToken:true,
    },
    //系统角色相关API
    queryAuthRoleByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authRole/queryByPage`,
        needToken:true,
    },
    //批量删除角色
    batchDeleteAuthRole: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authRole/batchDeleteItem`,
        needToken:true,
    },
    //新增角色
    addAuthRoleItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/authRole/addItem`,
        needToken:true,
    },
    //编辑角色
    editAuthRoleItem: {
        method: 'PUT',
        url: `${httpUrl}/api/v1/authRole/updateItem`,
        needToken:true,
    },
    //查询所有角色信息
    queryAllAuthRole: {
        method: 'GET',
        url: `${httpUrl}/api/v1/authRole/queryAllAuthRole`,
        needToken:true,
    },
    //查询角色具备的权限信息
    queryRolePermission: {
        method: 'GET',
        url: `${httpUrl}/api/v1/authRole/queryRolePermission`,
        needToken:true,
    },
    //单个文件上传
    uploadSingleFile: {
        method: 'post',
        jsonStatus: true,
        url: `${httpUrl}/api/platformFile/uploadFile`,
        needToken:true,
    },
    //系统日志API
    queryPlatformApiLogByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformApiLog/queryByPage`,
        needToken:true,
    },
    batchDeletePlatformApiLog: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformApiLog/batchDeleteItem`,
        needToken:true,
    },
    //统计系统访问量
    statisticsVisitCount: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformApiLog/statisticsVisitCount`,
        needToken:true,
    },
    //查询系统角色对应的用户数量
    queryAuthRoleCount: {
        method: 'POST',
        url: `${httpUrl}/api/v1/statistics/queryAuthRoleCount`,
        needToken:true,
    },
    //单个文件删除
    deleteFileApi: {
        method: 'DELETE',
        jsonStatus: true,
        url: `${httpUrl}/api/platformFile/deleteFileByFileName`,
        needToken:true,
    },

    //--------------------------------
    /*查询所有平台用户信息*/
    queryAllPlatformUser: {
        method: 'GET',
        url: `${httpUrl}/api/v1/platformUser/queryAllPlatformUser`,
        needToken:true,
    },
    /*分页查询平台用户信息*/
    queryPlatformUserByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformUser/queryByPage`,
        needToken:true,
    },
    /*新增平台用户信息*/
    addPlatformUserItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformUser/addItem`,
        needToken:true,
    },
    /*编辑平台用户信息*/
    editPlatformUserItem: {
        method: 'PUT',
        url: `${httpUrl}/api/v1/platformUser/updateItem`,
        needToken:true,
    },
    /*批量删除平台用户信息*/
    batchDeletePlatformUser: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformUser/batchDeleteItem`,
        needToken:true,
    },
    /*导入平台用户信息*/
    importPlatformUserItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformUser/importData`,
        needToken:true,
    },
    /*导出平台用户信息*/
    exportPlatformUserItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformUser/exportData`,
        needToken:true,
        responseType: 'blob',
    },
    /*查询所有视频信息*/
    queryAllVideoData: {
        method: 'GET',
        url: `${httpUrl}/api/v1/videoData/queryAllVideoData`,
        needToken:true,
    },
    /*分页查询视频信息*/
    queryVideoDataByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/videoData/queryByPage`,
        needToken:true,
    },
    /*编辑视频信息*/
    editVideoDataItem: {
        method: 'PUT',
        url: `${httpUrl}/api/v1/videoData/updateItem`,
        needToken:true,
    },
    /*批量删除视频信息*/
    batchDeleteVideoData: {
        method: 'POST',
        url: `${httpUrl}/api/v1/videoData/batchDeleteItem`,
        needToken:true,
    },
    /*导出视频信息*/
    exportVideoDataItem: {
        method: 'POST',
        url: `${httpUrl}/api/v1/videoData/exportData`,
        needToken:true,
        responseType: 'blob',
    },
    //--------------------------------
};
export default globalServices;



// WEBPACK FOOTER //
// ./src/services/api.js